import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import { shade } from 'polished';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      height: 'calc(100vh - 40px)',
      '& > a': {
        color: '#ff9000',
        marginTop: '24px',
        textDecoration: 'none',
        display: 'flex',
        alignItems: 'center',

        transition: 'color 0.2s',

        '&:hover': {
          color: `${shade(0.2, '#ff9000')}`,
        },

        svg: {
          marginRight: '16px',
        },
      },
    },
    submitButton: {
      marginTop: theme.spacing(3),
    },
    title: {
      marginTop: theme.spacing(4),
      marginBottom: theme.spacing(4),
    },
  }),
);

export default useStyles;
